import { useTranslation } from 'next-i18next';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import ConversationSkeleton from '../ConversationSkeleton';
import { ConversationListEntry } from './ConversationListEntry';

interface conversationListInterface {
  isLoading?: boolean;
  setSelectedTab?: (index: 0 | 1 | 2) => void;
}

const ConversationList = ({ isLoading = false, setSelectedTab }: conversationListInterface) => {
  const { t } = useTranslation();

  const messagingConversations = useSelector(({ common }) => common.attendeeMessaging?.conversations);

  return (
    <div className="w-full h-full overflow-auto">
      {isLoading && <ConversationSkeleton />}
      {!isLoading && (
        <>
          {messagingConversations && messagingConversations.length === 0 && (
            <div className="w-full h-full grid place-items-center">
              <div className="flex flex-col items-center space-y-2 space-x-4">
                <p className="text-lg italic text-slate-500">{t('event:messaging.empty-conversation-list-text-1')}</p>
                <p className="text-lg font-bold text-slate-800 cursor-pointer no-underline hover:underline" onClick={() => setSelectedTab?.(1)}>
                  {t('event:messaging.empty-conversation-list-text-2')}
                </p>
              </div>
            </div>
          )}
          {messagingConversations?.map((conversation, index) => (
            <ConversationListEntry conversation={conversation} index={index} />
          ))}
        </>
      )}{' '}
    </div>
  );
};
export default ConversationList;
